import React, { useState } from 'react';
import { Table, Input, Button } from 'antd';
// import { DeleteOutlined } from '@ant-design/icons';

const AddRowTable = ({
  tableHeaders,
  headerSelector,
  withAction,
  setDataSource,
  dataSource,
  isDisabled,
  inputDisabled,
}) => {
  const [count, setCount] = useState(0);
  const columns = tableHeaders.map((header, index) => ({
    title: header,
    dataIndex: headerSelector[index],
    key: headerSelector[index],
    sorter: (a, b) => {
      const valueA = a[headerSelector[index]];
      const valueB = b[headerSelector[index]];

      if (typeof valueA === "string" && typeof valueB === "string") {
        return valueA.localeCompare(valueB, undefined, {
          sensitivity: "base",
        });
      } else if (typeof valueA === "number" && typeof valueB === "number") {
        return valueA - valueB;
      } else if (valueA instanceof Date && valueB instanceof Date) {
        return valueA - valueB;
      } else {
        return typeof valueA === "string" ? -1 : 1;
      }
    },
    sortDirections: ["descend", "ascend"],
    render: (text, record) => {
      return (
        <Input
          disabled={inputDisabled}
          className='add-row-width'
          value={record[headerSelector[index]]}
          onChange={(e) => handleInputChange(e, record, headerSelector[index])}
        />
      );
    },
    
  }));

  if (withAction) {
    columns.push({
      title: 'Action',
      dataIndex: 'action',
      align: 'center',
      key: 'action',
      render: (_, record) => {
        return(
        <div className='center'>
          <Button disabled={inputDisabled} onClick={() => handleDelete(record)} type="link" className='cancel-color btn-header'>
            Delete
          </Button>
        </div>
        )
      },
    });
  }

  const handleInputChange = (e, key, dataIndex) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => key === item);
    if (index > -1) {
      newData[index][dataIndex] = e.target.value;
      setDataSource(newData);
    }
  };

  const handleAdd = () => {
    const newData = {
      key: count,
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item !== key);
    setDataSource(newData);
  };

  return (
    <div>
      <Table
        bordered
        dataSource={dataSource}
        columns={columns}
        pagination={false}
      />
      <Button onClick={handleAdd} disabled={isDisabled} type="primary" style={{ marginTop: 16 }} className='button-color btn-header'>
        Add a row
      </Button>
    </div>
  );
};

export default AddRowTable;
